







































































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import PermissionService from '@/utils/permission-service';
import { fuzzy } from '@/components/UI/Table/filtering';
import gql from 'graphql-tag';
import { KeysArray } from '@/utils/utils';
import { GQL_orderNewDataMandatorySupplierFields, GQL_orderNewDataMandatorySupplierFields_currentUser_currentUnit } from '@/queries/__generated__/orderNewDataMandatorySupplierFields';
import { SmartQuery } from 'vue-apollo-decorator';
import { ORDER_NEW_DATA_MANDATORY_SUPPLIER_FIELDS } from '@/queries/Order';
import { get } from 'lodash';
import RecurringOrderCreateNextOrderButton from './RecurringOrderCreateNextOrderButton.vue';
import RecurringOrderGenerateForDateButton from './RecurringOrderGenerateForDateButton.vue';
import SApolloTable from '@/components/UI/Table/SApolloTable.vue';
import { GQL_currentUnitRecurringOrders_currentUnit_recurringOrders } from '@/queries/__generated__/currentUnitRecurringOrders';

const ALL_RECURRING_ORDERS = gql`
query currentUnitRecurringOrders {
    currentUnit {
      id
      recurringOrders {
        id
        payableAmount
        currencyCode
        customerParty {
          id
          name
          unofficialName
          phone
          mobile
          email
          partyIdentificationScheme
          partyIdentification
          city
          zip
          streetName
          additionalStreetName
          reference
          country {
            code
            name
          }
          countryCode
          vatRegulation
          foretaksRegisteredSince
        }
        recurringOrderSetting {
          id
          active
          startDate
          endDate
          dateOffset
          interval
          lastDateCreatedOn
          nextDate
        }
        note
      }
    }
  }
`;


@Component({
  components: {
    RecurringOrderCreateNextOrderButton,
    RecurringOrderGenerateForDateButton,
  },
})
export default class RecurringOrderList extends Vue {
  @SmartQuery<RecurringOrderList, GQL_orderNewDataMandatorySupplierFields>({
    query: ORDER_NEW_DATA_MANDATORY_SUPPLIER_FIELDS,
    fetchPolicy: "no-cache",
    update(data) {
      const  requiredCompanyFields: KeysArray<GQL_orderNewDataMandatorySupplierFields_currentUser_currentUnit> = [
        'email',
        'address',
        'zip',
        'city',
      ];
      const currentUnit = data.currentUser?.currentUnit;
      return requiredCompanyFields.filter(key => {
        const value = currentUnit ? get(currentUnit, key) : null;
        return !(typeof value === 'string' && value.trim().length);
      });
    },
  }) public missingCompanyFields!: GQL_orderNewDataMandatorySupplierFields;
  @Ref() private table?: SApolloTable<GQL_currentUnitRecurringOrders_currentUnit_recurringOrders>;

  private ALL_RECURRING_ORDERS = ALL_RECURRING_ORDERS;
  private PermissionService = PermissionService;
  private fuzzyFilter = fuzzy;

  private resetTableResult() {
    this.table?.refetch();
  }
}
